export default "__VITE_ASSET__DPBS6aI3__"